import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { SecurityService } from 'src/app/shared/services/security.service';
import { debounceTime, filter } from 'rxjs/operators';
import { ModalSeleccionarVendedorComponent } from 'src/app/views/shared/modal-seleccionar-vendedor/modal-seleccionar-vendedor.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { ClienteProveedorService } from '../../../../services/cliente-proveedor.service';

@Component({
  selector: 'app-traspaso-masivo-modal-transferencia-cliente-vendedor',
  templateUrl: './modal-transferencia-cliente-vendedor.component.html',
  styleUrls: ['../traspaso-masivo-cliente.component.scss'],
  providers: [SecurityService]
})
export class ModalTransferenciaClienteVendedorComponent implements OnInit {

  readonly VENDEDOR_ORIGEN = 'VENDEDOR_ORIGEN'
  readonly VENDEDOR_DESTINO = 'VENDEDOR_DESTINO'

  // Modales
  @ViewChild('transferir', { static: true }) modalTransferir: ModalDirective;
  @ViewChildren(ModalSeleccionarVendedorComponent) modalesSeleccionVendedor: QueryList<ModalSeleccionarVendedorComponent>
  @Output() RespTraspCliente = new EventEmitter<any>(); //actualizar grilla principal


  @Input() enviarClientesSelecc: any; //Clientes recibidos cuando son seleccionados en vista principal

  // Form
  formHeader: FormGroup

  // Data &  Tmp
  processing: boolean = false
  private rutEmpresa: number
  private sucursalEmpresa: number
  vendedorOrigenSeleccionado: any = null
  vendedorDestinoSeleccionado: any = null
  vendedorOrigen: number;
  vendedorRut: string;
  vendedorOriginario: boolean = false
  clientesSeleccionados: any;
  diasSemana = {
    lunes: false,
    martes: false,
    miercoles: false,
    jueves: false,
    viernes: false,
    sabado: false,
    domingo: false
  };
  selectClientes: any;
  ClientSelect: any;
  dato: any;
  returnedTarget: any | null;
  returnedTodos: boolean = false;
  enableWeek: boolean;
  bandera: number = 0;
  checkEliminarVendedor: boolean = true;
  // getters
  get modalSeleccionarVendedorOrigen() {
    return this.modalesSeleccionVendedor.filter(mod => mod.origen === this.VENDEDOR_ORIGEN)[0]
  }
  get modalSeleccionarVendedorDestino() {
    return this.modalesSeleccionVendedor.filter(mod => mod.origen === this.VENDEDOR_DESTINO)[0]
  }

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private fb: FormBuilder,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private rutService: RutService,
    private formValidatorsService: FormValidatorsService,
    private toastService: ToastService,
    private clienteProveedorService: ClienteProveedorService
  ) {
    this.log = this.clog.log('MODAL-TRANSFERENCIA-CLIENTE-VENDEDOR')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())


    this.createForms();
    this.formChangesSubscriptions()
  }

  private createForms() {
    this.formHeader = this.fb.group({
      rutVendedorOrigen: [this.vendedorRut, Validators.required],
      rutVendedorDestino: [null, Validators.required],
      eliminar_vendedor: [true],
      HeredaIPT: [true, []],
      lunes: [false, []],
      martes: [false, []],
      miercoles: [false, []],
      jueves: [false, []],
      viernes: [false, []],
      sabado: [false, []],
      domingo: [false, []],
      todos: [false, []],
    });
  }

  private formChangesSubscriptions() {
    this.formHeader.get("rutVendedorOrigen").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutVendedorOrigen: string) => {
        this.modalSeleccionarVendedorOrigen.searchByRut(rutVendedorOrigen)
      })
    this.formHeader.get("rutVendedorDestino").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutVendedorDestino: string) => {
        this.modalSeleccionarVendedorDestino.searchByRut(rutVendedorDestino)
      })
  }

  /********* MODAL VENDEDOR ORIGEN *********/
  openModalSeleccionarVendedorOrigen() {
    this.modalSeleccionarVendedorOrigen.show()
  }

  load(rutseleccionadoVendedor) {

    this.clientesSeleccionados = this.enviarClientesSelecc.length
    this.formHeader.get('rutVendedorOrigen').setValue(rutseleccionadoVendedor)

    this.selectClientes = this.enviarClientesSelecc.map(clientes => {
      const paramsClientes = {
        rut: clientes.rut,
        codigo_direccion: clientes.codigo_direccion
      }

      return paramsClientes
    })

    this.ClientSelect = this.enviarClientesSelecc.map(clientes => {

      const params = {
        lunes: clientes.lunes,
        martes: clientes.martes,
        miercoles: clientes.miercoles,
        jueves: clientes.jueves,
        viernes: clientes.viernes,
        sabado: clientes.sabado,
        domingo: clientes.domingo,
      }

      return params
    })


    //** OBTENER OBJETO DE DIAS AL COMBINAR LOS CLIENTES */

    this.dato = {
      lunes: this.ClientSelect.find(element => element.lunes === true ? true : false) != undefined ? this.ClientSelect.find(element => element.lunes === true ? true : false) : false,
      martes: this.ClientSelect.find(element => element.martes === true ? true : false) != undefined ? this.ClientSelect.find(element => element.martes === true ? true : false) : false,
      miercoles: this.ClientSelect.find(element => element.miercoles === true ? true : false) != undefined ? this.ClientSelect.find(element => element.miercoles === true ? true : false) : false,
      jueves: this.ClientSelect.find(element => element.jueves === true ? true : false) != undefined ? this.ClientSelect.find(element => element.jueves === true ? true : false) : false,
      viernes: this.ClientSelect.find(element => element.viernes === true ? true : false) != undefined ? this.ClientSelect.find(element => element.viernes === true ? true : false) : false,
      sabado: this.ClientSelect.find(element => element.sabado === true ? true : false) != undefined ? this.ClientSelect.find(element => element.sabado === true ? true : false) : false,
      domingo: this.ClientSelect.find(element => element.domingo === true ? true : false) != undefined ? this.ClientSelect.find(element => element.domingo === true ? true : false) : false,
    }

    this.returnedTarget = this.dato
    this.returnedTarget = {
      lunes: this.dato.lunes.lunes != undefined ? true : false,
      martes: this.dato.martes.martes != undefined ? true : false,
      miercoles: this.dato.miercoles.miercoles != undefined ? true : false,
      jueves: this.dato.jueves.jueves != undefined ? true : false,
      viernes: this.dato.viernes.viernes != undefined ? true : false,
      sabado: this.dato.sabado.sabado != undefined ? true : false,
      domingo: this.dato.domingo.domingo != undefined ? true : false
    }

    if (this.returnedTarget.lunes != false && this.returnedTarget.martes != false && this.returnedTarget.miercoles != false &&
      this.returnedTarget.jueves != false && this.returnedTarget.viernes != false && this.returnedTarget.sabado != false &&
      this.returnedTarget.domingo != false
    ) {
      this.returnedTodos = true;
    }

    //** COPIA DE LA SEMANA DEL VENDEDOR ORIGEN AL VENDEDOR DESTINO */

    this.formHeader.get('lunes').setValue(this.returnedTarget.lunes);
    this.formHeader.get('martes').setValue(this.returnedTarget.martes);
    this.formHeader.get('miercoles').setValue(this.returnedTarget.miercoles);
    this.formHeader.get('jueves').setValue(this.returnedTarget.jueves);
    this.formHeader.get('viernes').setValue(this.returnedTarget.viernes);
    this.formHeader.get('sabado').setValue(this.returnedTarget.sabado);
    this.formHeader.get('domingo').setValue(this.returnedTarget.domingo);
    this.formHeader.get('todos').setValue(this.returnedTodos);

    //ABRIR MODAL
    this.show();
  }

  OnchangeL({ checked }) {
    console.log(checked);
    this.diasSemana.lunes = checked;
    this.bandera = 1;

  }
  OnchangeM({ checked }) {
    this.diasSemana.martes = checked;
    this.bandera = 1;

  }

  OnchangeMi({ checked }) {
    this.diasSemana.miercoles = checked;
    this.bandera = 1;

  }

  OnchangeJ({ checked }) {
    this.diasSemana.jueves = checked;
    this.bandera = 1;

  }

  OnchangeV({ checked }) {
    this.diasSemana.viernes = checked;
    this.bandera = 1;

  }

  OnchangeS({ checked }) {
    this.diasSemana.sabado = checked;
    this.bandera = 1;

  }

  OnchangeD({ checked }) {
    this.diasSemana.domingo = checked;
    this.bandera = 1;

  }

  OnchangeT({ checked }) {
    this.formHeader.get('lunes').setValue(checked)
    this.formHeader.get('martes').setValue(checked)
    this.formHeader.get('miercoles').setValue(checked)
    this.formHeader.get('jueves').setValue(checked)
    this.formHeader.get('viernes').setValue(checked)
    this.formHeader.get('sabado').setValue(checked)
    this.formHeader.get('domingo').setValue(checked)

    this.diasSemana.lunes = checked;
    this.diasSemana.martes = checked;
    this.diasSemana.miercoles = checked;
    this.diasSemana.jueves = checked;
    this.diasSemana.viernes = checked;
    this.diasSemana.sabado = checked;
    this.diasSemana.domingo = checked;

    this.bandera = 1;

  }

  OnchangeITP({ checked }) {
    if (checked === false) {
      this.formHeader.get('lunes').setValue(false);
      this.formHeader.get('martes').setValue(false);
      this.formHeader.get('miercoles').setValue(false);
      this.formHeader.get('jueves').setValue(false);
      this.formHeader.get('viernes').setValue(false);
      this.formHeader.get('sabado').setValue(false);
      this.formHeader.get('domingo').setValue(false);
      this.formHeader.get('todos').setValue(false);
    } else {
      this.formHeader.get('lunes').setValue(this.returnedTarget.lunes);
      this.formHeader.get('martes').setValue(this.returnedTarget.martes);
      this.formHeader.get('miercoles').setValue(this.returnedTarget.miercoles);
      this.formHeader.get('jueves').setValue(this.returnedTarget.jueves);
      this.formHeader.get('viernes').setValue(this.returnedTarget.viernes);
      this.formHeader.get('sabado').setValue(this.returnedTarget.sabado);
      this.formHeader.get('domingo').setValue(this.returnedTarget.domingo);
      this.formHeader.get('todos').setValue(this.returnedTodos);
    }
  }


  OnchangeDeleteVendedor({ checked }) {
    if (checked === true) {
      this.checkEliminarVendedor = checked;
    } else {
      this.checkEliminarVendedor = checked;
    }

  }

  onVendedorOrigenSeleccionado({ data }) {
    this.vendedorOrigenSeleccionado = data
    this.formHeader.get('rutVendedorOrigen').setValue(this.rutService.AgregarDV(this.vendedorOrigenSeleccionado.rut))
  }

  onVendedorOrigenNoEncontrado() {
    this.vendedorOrigenSeleccionado = null
  }
  /********* MODAL VENDEDOR ORIGEN *********/

  /********* MODAL VENDEDOR ORIGEN *********/
  openModalSeleccionarVendedorDestino() {
    this.modalSeleccionarVendedorDestino.show()
  }

  onVendedorDestinoSeleccionado({ data }) {
    this.vendedorDestinoSeleccionado = data
    this.formHeader.get('rutVendedorDestino').setValue(this.rutService.AgregarDV(this.vendedorDestinoSeleccionado.rut))
  }

  onVendedorDestinoNoEncontrado() {
    this.vendedorDestinoSeleccionado = null
  }
  /********* MODAL VENDEDOR ORIGEN *********/

  show() {
    this.modalTransferir.show()
  }


  transferirVendedor() {
    this.processing = true
    const valid = this.formValidatorsService.validate(this.formHeader)
    if (!valid)
      return


    if (this.formHeader.get('HeredaIPT').value === true && this.bandera === 0) {
      this.diasSemana = {
        lunes: this.returnedTarget.lunes,
        martes: this.returnedTarget.martes,
        miercoles: this.returnedTarget.miercoles,
        jueves: this.returnedTarget.jueves,
        viernes: this.returnedTarget.viernes,
        sabado: this.returnedTarget.sabado,
        domingo: this.returnedTarget.domingo
      }

    } else {
      this.diasSemana = {
        lunes: this.formHeader.get('lunes').value,
        martes: this.formHeader.get('martes').value,
        miercoles: this.formHeader.get('miercoles').value,
        jueves: this.formHeader.get('jueves').value,
        viernes: this.formHeader.get('viernes').value,
        sabado: this.formHeader.get('sabado').value,
        domingo: this.formHeader.get('domingo').value
      }
    }

    const InputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        vendedor_codigo_origen: this.vendedorOrigenSeleccionado.codigo,
        vendedor_codigo_destino: this.vendedorDestinoSeleccionado.codigo,
        herreda_ipt: this.formHeader.get('HeredaIPT').value,
        remover_vendedores: this.checkEliminarVendedor,
        lunes: this.diasSemana.lunes,
        martes: this.diasSemana.martes,
        miercoles: this.diasSemana.miercoles,
        jueves: this.diasSemana.jueves,
        viernes: this.diasSemana.viernes,
        sabado: this.diasSemana.sabado,
        domingo: this.diasSemana.domingo
      },
      clientes: this.selectClientes
    }

    this.log('InputParams', JSON.stringify(InputParams))

    if (this.clientesSeleccionados === 0) {
      this.toastService.warning('Se deben seleccionar clientes')
    } else {

      this.clienteProveedorService.TransferenciaVendedor(InputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null
        if (!ok) {
          this.processing = false
          this.messageRendererService.showErrors(mensajes)
          return
        }

        this.modalTransferir.hide();
        this.RespTraspCliente.emit()
        this.toastService.success('Operación exitosa')
        this.processing = false

      })

    }

  }

  limpiarForm() {
    this.formHeader.reset()
    this.formHeader.markAsPristine()
    this.formHeader.markAsUntouched()
  }

}
